import React from 'react';
import { Link } from 'react-router-dom';
import { IconClock, IconMapPin } from '@tabler/icons-react';
import DateBlock from './DateBlock';
import StatusBadge from '../common/StatusBadge';
import Button from '../common/Button';
import { PATHS, toPath } from '../../routes/paths';
import { formatTime } from '../../utils/date';
import { accentFor } from '../../utils/constants';

/** Full appointment card used on the Appointments tab. */
export default function AppointmentCard({ appointment: a, onCancel, tab = 'upcoming' }) {
  const detail = toPath(PATHS.appointmentDetail, { id: a.id });
  const subtitle = [a.doctor?.specialty, a.visitType].filter(Boolean).join(' · ');
  return (
    <article className="card appt-card">
      <Link to={detail} className="appt-card__main">
        <DateBlock date={a.date} accent={a.status === 'cancelled' ? undefined : accentFor(a.doctor?.name)} />
        <div className="u-grow">
          <StatusBadge status={a.status} />
          <h3 className="appt-card__name">{a.doctor?.name}</h3>
          <p className="appt-card__meta">{subtitle}</p>
          <p className="appt-card__facts">
            <span><IconClock size={16} />{formatTime(a.time)}</span>
            <span><IconMapPin size={16} />{a.location}</span>
          </p>
        </div>
      </Link>
      {tab === 'upcoming' && (
        <div className="appt-card__actions">
          <Button variant="danger-outline" size="sm" onClick={() => onCancel?.(a)}>Cancel</Button>
          <Button variant="outline" size="sm" to={toPath(PATHS.reschedule, { id: a.id })}>Reschedule</Button>
        </div>
      )}
      {tab === 'past' && (
        <div className="appt-card__actions">
          <Button variant="outline" size="sm" to={detail}>View details</Button>
          <Button variant="outline" size="sm" to={toPath(PATHS.book, { doctorId: a.doctor?.id })}>Book again</Button>
        </div>
      )}
      {tab === 'cancelled' && (
        <div className="appt-card__actions appt-card__actions--single">
          <Button variant="outline" size="sm" to={toPath(PATHS.book, { doctorId: a.doctor?.id })}>Book again</Button>
        </div>
      )}
    </article>
  );
}
